import { IConsentForm } from "@/api/dtos";
import { EConsentUserType } from "@/contexts/EConsentContext";
import { IInstitution, IPatient, IEvent, IFormAfterSubmit, OnlinePatientManagementContext } from "@ngt/opms";
import { useContext, useCallback } from "react";
import { useParams, useNavigate } from "react-router";


const useEConsentFormAfterSubmit =  <TData extends IConsentForm = IConsentForm>(
    institution: IInstitution | null | undefined,
    patient: IPatient | null | undefined, 
    event: IEvent | null | undefined,
    user: EConsentUserType | null | undefined,
    consentGuid: string | null | undefined,
    onAfterSubmit?: IFormAfterSubmit<TData> | null,
    afterFormSave?: (institution?: IInstitution | null, patient?: IPatient | null, event?:  IEvent | null, form?: TData | null, user?: EConsentUserType | null, consentGuid?: string | null) => void,
    afterFormSaveAndReturn?: (institution?: IInstitution | null, patient?: IPatient | null, event?: IEvent | null, form?: TData | null, user?: EConsentUserType | null, consentGuid?: string | null) => void,
    patientRefresh?: () => Promise<IPatient | undefined>
) => {
    const params = useParams();
    const navigate = useNavigate();
    const { routeParameters, serviceStackClient } = useContext(OnlinePatientManagementContext);
    
    const onAfterSubmitToUse: IFormAfterSubmit<TData> = useCallback(async (newData, formState, formActions) => {
        if (onAfterSubmit) {
            const result = await onAfterSubmit(newData, formState, formActions);

            if (result !== undefined) {
                return result;
            }
        }

        if (patientRefresh) {
            await patientRefresh();
        }

        if (user === EConsentUserType.Investigator) {
            return;
        }

        const { submitType } = formState.value as any
        if (submitType === 'save') {
            if (afterFormSave) {
                afterFormSave(institution, patient, event, newData, user);
            }
        }
        else if (afterFormSaveAndReturn) {
            afterFormSaveAndReturn(institution, patient, event, newData, user);
        }
        else {
            const formDefinitionCode = params[routeParameters.formDefinitionCode];
            navigate(`/trial-consent/econsent/${formDefinitionCode}/${consentGuid}`)
        }
    }, [serviceStackClient, institution, patient, event, consentGuid, user, params, routeParameters, navigate, onAfterSubmit, afterFormSave, afterFormSaveAndReturn, patientRefresh])

    return onAfterSubmitToUse;
};

export default useEConsentFormAfterSubmit;
